import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-render-preview-dialog',
  templateUrl: './render-preview-dialog.component.html',
  styleUrls: ['./render-preview-dialog.component.scss']
})
export class RenderPreviewDialogComponent implements OnInit {
  public Src: any

  constructor(@Inject(MAT_DIALOG_DATA) data: any) {
    this.Src = data;
  }

  ngOnInit(): void {
  }

}
